import { render, staticRenderFns } from "./VizModePill.vue?vue&type=template&id=2d8c960c&scoped=true&"
import script from "./VizModePill.vue?vue&type=script&lang=js&"
export * from "./VizModePill.vue?vue&type=script&lang=js&"
import style0 from "./VizModePill.vue?vue&type=style&index=0&id=2d8c960c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8c960c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
